export default "__VITE_ASSET__ByOuR8gz__"